import React from 'react'
import { GoogleMap, useJsApiLoader, HeatmapLayer } from '@react-google-maps/api'
const libraries = ['visualization']
const googleMapsApiKey = "AIzaSyAj0BB9yiU23jGNhpWI8YXMqLmqDHHiZZo"

function HeatMap(data) {
    const { isLoaded, loadError } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey,
        libraries
    })
    return isLoaded ? <GoogleMap
        mapContainerStyle={{
            width: '100%',
            height: '300px',
            borderRadius: '5px'
        }}
        center={{ lat: data.lat, lng: data.lng}}
        zoom={10}
    >
        <HeatmapLayer data={(data.data).map(d => new window.google.maps.LatLng(d.lat, d.lng))} options={{ radius: 50 }} />
    </GoogleMap> : (loadError ? <div style={{ color: '#fff' }}>Error</div> : <div style={{ color: '#fff' }}>Loading</div>)
}

/*
[
            new window.google.maps.LatLng(30.2556907, -81.5402197),
            new window.google.maps.LatLng(30.2556907, -81.5402197),
            new window.google.maps.LatLng(30.2556907, -81.5402197),
            new window.google.maps.LatLng(30.2563856, -81.5346959),
            new window.google.maps.LatLng(30.2563856, -81.5346959),
            new window.google.maps.LatLng(30.2623585, -81.5297348),
            new window.google.maps.LatLng(30.2528465, -81.5256565)
        ]
*/

export default HeatMap